module.exports = __webpack_public_path__ + "images/0fa7fbde6e674c44a20312dda9704e60-nurse1.jpg";